import User from '@/models/User'
import { Model } from '@vuex-orm/core'

export default class Trace extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'traces'

  // List of all fields (schema) of the user model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id: this.number(null),
      url: this.string(''),
      user_id: this.number(null),
      user: this.belongsTo(User, 'user_id'),
      created: this.attr(null),
      description: this.string(null),
      data: this.attr(null) // FIXME JSON?
    }
  }

  withUser () {
    // This feels a bit wrong, but it seems to work.
    return Trace.query().whereId(this.id).with('user').first()
  }
}
